import { render } from "./ResourcePage.vue?vue&type=template&id=5cc75ae4"
import script from "./ResourcePage.vue?vue&type=script&lang=js"
export * from "./ResourcePage.vue?vue&type=script&lang=js"

import "./ResourcePage.vue?vue&type=style&index=0&id=5cc75ae4&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__